export const defaultPortfolioField = [
  "image",
  "title",
  "portfoliocategory",
  "createdAt",
  "comment_count",
];

export const defaultPortfolioCategoryField = [
  "lowercase_category",
  "description",
  "portfolio_count",
  "createdAt",
  "action"
];

export const defaultPortfolioCommentsField = [
  "image",
  "title",
  "comment_count",
  "action",
];

export const PORTFOLIO_SORT_FIELD = ["title", "portfoliocategory", "comment_count", "portfolio_publish_date", "createdAt"];
export const PORTFOLIO_CATEGORY_SORT_FIELD = ["lowercase_category", "title", "createdAt", "portfolio_count"];
export const PORTFOLIO_COMMENTS_SORT_FIELD = ["title", "comment_count", "createdAt"]